import { Controller } from '@hotwired/stimulus'

const COPIED_VISIBLE_MS = 2000

export default class extends Controller {
  static values = { text: String }
  static targets = ['copied', 'button']

  declare textValue: string
  declare copiedTarget: HTMLElement
  declare hasCopiedTarget: boolean
  declare buttonTarget: HTMLElement
  declare hasButtonTarget: boolean
  private hideTimer?: number

  async copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.textValue)
    } catch {
      // The browser refuses when the page is not focused; the text stays on screen to copy by hand.
      return
    }

    if (!this.hasCopiedTarget) {
      return
    }

    this.toggleCopied(true)
    window.clearTimeout(this.hideTimer)
    this.hideTimer = window.setTimeout(() => {
      this.toggleCopied(false)
    }, COPIED_VISIBLE_MS)
  }

  private toggleCopied(copied: boolean): void {
    this.copiedTarget.classList.toggle('tw-hidden', !copied)
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.toggle('tw-hidden', copied)
    }
  }

  disconnect(): void {
    window.clearTimeout(this.hideTimer)
  }
}
